angular.module("monitorPratica.components", [])
    .component("monitorPratica", {
        templateUrl: "ng/components/monitorPratica/monitorPratica.view.html",
        bindings: {
            model: "=",
            annoPreventivo: "=",
            numeroPreventivo: "="
        },
        controllerAs: "monitorPraticaCtrl",
        controller: function MonitorPratica(
            $workflowService,
            $financialService,
            FinancialModel,
            $timeout,
            $rootScope,
            $transactionFactory,
            $location,
            $orderService,
            $simulationService
        ) {
            var self = this;

            self.$onInit = function () {

                self.viewIndex = 0;
                self.filterIsPresent = $transactionFactory.getFilters() ? true : false;
                self.loadingFooter = {
                    backStep: false
                }
                self.numeroAnno = self.model.numeroAnno;
                self.numeroPrev = self.model.numeroPreventivo;
                self.cdRaggrConvenzione = self.model.cdRaggrConvenzione;
                self.showAccordionIdentificatori = false;
                var model = self.model.listAppSnapshot.length && getModelFromData(self.model.listAppSnapshot);

                self.financialModelFromMetadata = FinancialModel.build(model);
                self.financialModelFromMetadata.leasingData.preventivo.cdRaggrConvenzione = self.cdRaggrConvenzione;
                self.financialModelFromMetadata.leasingData.preventivo.numero = self.numeroPrev;
                self.financialModelFromMetadata.leasingData.preventivo.anno = self.numeroAnno;

                self.getNotePreventivo();
                self.snapshots = self.model.listAppSnapshot.map(function (element) {
                    return {
                        dynamicInputPojo: {
                            financialCustomer: JSON.parse(element.metadata).dynamicInputPojo.financialCustomer,
                            financialVendor: JSON.parse(element.metadata).dynamicInputPojo.financialVendor,
                            goHome: JSON.parse(element.metadata).dynamicInputPojo.goHome,
                            idWfInstance: JSON.parse(element.metadata).dynamicInputPojo.idWfInstance,
                            leasingData: JSON.parse(element.metadata).dynamicInputPojo.leasingData,
                            monitor: JSON.parse(element.metadata).dynamicInputPojo.monitor,
                            passiveViewIndex: JSON.parse(element.metadata).dynamicInputPojo.passiveViewIndex,
                            viewIndex: JSON.parse(element.metadata).dynamicInputPojo.viewIndex,
                            workflowInfo: JSON.parse(element.metadata).dynamicInputPojo.workflowInfo,
                            monitorDate: element.insertDate
                        }
                    }
                })
                chiamaRestRetriveViewInfo();
                getIdentificazione(self.financialModelFromMetadata.leasingData.id);
                if (self.financialModelFromMetadata.leasingData.contratto.numero && self.financialModelFromMetadata.leasingData.contratto.modulo) {
                    self.filter = {
                        orderColumnName: "ID_ORDER",
                        orderType: "DESC",
                        idContract: self.financialModelFromMetadata.leasingData.contratto.numero,
                        module: self.financialModelFromMetadata.leasingData.contratto.modulo
                    };
                    self.getOrdiniAcquisto();
                }
                getProcedureContratto();

            };
            var getModelFromData = function (value) {
                var snapshot = value && value[value.length - 1];
                var metadata = JSON.parse(snapshot.metadata);
                return metadata.dynamicInputPojo;
            }


            self.getNotePreventivo = function () {
                self.startRestGetNote = true;
                $financialService.getNotePreventivo(self.model.id)
                    .then(function (response) {
                        self.listaNote = response.note;
                        self.showHideNote = response.hidden;
                        self.startRestGetNote = false;
                    })
                    .catch(function (error) {
                        self.startRestGetNote = false;
                    })
            }

            var getIdentificazione = function (id) {

                $financialService.getIdentificazioneSaved(id)
                    .then(function (response) {

                        if (response.success) {
                            self.modelOfIdentificazioneSaved = response;
                            self.showAccordionIdentificatori = response.showMonitor;
                        }
                    })
            }

            self.indexPageSelected = function (index) {
                if (self.snapshots[index].dynamicInputPojo.viewIndex == 10) {
                    self.snapshots[index].dynamicInputPojo.passiveViewIndex = self.snapshots[index].dynamicInputPojo.viewIndex;
                }
                self.snapshots[index].dynamicInputPojo.viewIndex = self.snapshots[index].dynamicInputPojo.passiveViewIndex;
                self.currentIndex = self.snapshots[index].dynamicInputPojo.passiveViewIndex;
                self.currentModel = self.snapshots[index].dynamicInputPojo;
                self.currentModel.monitor = true;
                self.portalRunnedPractice = self.model.listAppSnapshot[index].appChannel;
                self.viewIndex = 1;

            }

            self.backStep = function () {
                self.loadingFooter.backStep = true;
                $timeout(function () {
                    self.loadingFooter.backStep = false;
                    self.viewIndex = 0;
                }, 1000)
            }

            self.getWizardMap = function (viewIndex) {

                if ($rootScope.wizardMap.find(function (element) { return element.index == viewIndex })) {
                    return $rootScope.wizardMap.find(function (element) {
                        return element.index == viewIndex;
                    }).viewName;
                }
            }

            self.gotoHomeWithFilter = function () {
                $rootScope.returnToHomeWithFilters = true;
                $location.path("/");
            }

            self.getOrdiniAcquisto = function () {

                $orderService.searchOrder(self.filter)
                    .then(function (response) {
                        self.listAppOrder = response.listAppOrder
                        self.filter.totalPages = getTotalPages(response.totalCount);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }

            var getTotalPages = function (totalCount) {
                //se il resto è zero non va aggiunto +1
                var addPlusOneToTotal = 0;
                var totModuloResult = totalCount % Number(self.filter.limit);
                if (totModuloResult > 0) {
                    addPlusOneToTotal = 1;
                }
                return (Math.floor(totalCount / Number(self.filter.limit))) + addPlusOneToTotal;
            }

            var getProcedureContratto = function () {
                $financialService.getProcedureContratto(self.financialModelFromMetadata.leasingData.id)
                    .then(function (response) {
                        self.listaProcedure = response.listProcedContratto;
                    })
            }

            self.hideFooter = function (value) {
                self.showFooter = value;
            }

            var chiamaRestRetriveViewInfo = function () {
                self.loading = true;
                $simulationService.retriveViewInfo(self.model.listAppSnapshot[0].idWfInstance)
                    .then(function (response) {
                        self.financialModelFromRest = FinancialModel.build(response.financialModel)
                        self.loading = false;
                    })
                    .catch(function (error) {
                        self.loading = false;
                    })
            }
        }
    });